import React from 'react';
import { Group, Text, Switch } from '@mantine/core';
import ClickableHelpText from './ClickableHelpText';

const theme = {
  background: { elevated: '#2D333B', tertiary: '#21262D' },
  state: { success: '#10B981' },
  border: { primary: '#374151' },
  text: { primary: '#F9FAFB' }
};

const CompactToggle: React.FC<{
  label: string;
  helpText?: string;
  detailedInfo?: string;
  checked: boolean;
  disabled?: boolean;
  onChange: (checked: boolean) => void;
}> = ({ label, helpText, detailedInfo, checked, disabled, onChange }) => (
  <div style={{ 
    padding: '8px 12px',
    backgroundColor: checked ? `${theme.state.success}15` : theme.background.elevated,
    borderRadius: '6px',
    border: `1px solid ${checked ? theme.state.success : theme.border.primary}`,
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    transition: 'all 0.2s ease'
  }}>
    <Group justify="space-between" align="center">
      <Text fw={500} size="sm" c={checked ? theme.state.success : theme.text.primary}>
      {label}
      </Text>
      <Switch
      checked={checked}
      onChange={(e) => onChange(e.currentTarget.checked)}
      size="sm"
      disabled={disabled === true}
      color={checked ? theme.state.success : theme.border.primary}
      styles={{
        track: {
        backgroundColor: checked ? theme.state.success : theme.background.tertiary,
        borderColor: checked ? theme.state.success : theme.border.primary,
        },
      }}
      />
    </Group>
    {helpText && (
      <ClickableHelpText 
        text={helpText} 
        detailedInfo={detailedInfo || helpText}
      />
    )}
  </div>
);

export default CompactToggle;
